export const Loader = () => {
  return (
    <div className="product-list-tile d-flex bg-white padding-16">
      <div className="spinner-icon d-flex align-items-center">
        <div className="loading-spinner" />
      </div>
    </div>
  );
};
